<template>
  <div>
    <v-navigation-drawer
      v-model="navigationVisibilityStore.appMenuVisibility"
      color="outline"
      permanent
      width="190"
      class="position-fixed"
    >
      <v-list>
        <v-list-item v-if="store.state.global.context.selection.organisation">
          <v-list-item-title
            class="text-button d-flex justify-space-between align-center"
            background-color="primary"
          >
            {{ store.state.global.context.selection.organisation.name }}
            <v-btn
              size="small"
              icon="mdi-close"
              density="compact"
              color="background"
              variant="outlined"
              @click="navigationVisibilityStore.setAppMenuNotVisible"
            />
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <router-view name="main-menu" />
      </v-list>
      <template #append>
        <div v-if="hasOrganisationSelection" class="pa-2">
          <OrganisationSelector
            :initial-org-id="initialOrgId"
            @selected="selectOrganisation"
          />
        </div>
        <div v-if="frontendVersion" class="ml-3 mt-2 has-text-grey-light">
          v{{ frontendVersion }}
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useNavigationVisibilityStore } from '@/store/NavigationVisibilityStore'

import OrganisationSelector from './OrganisationSelector.vue'

const navigationVisibilityStore = useNavigationVisibilityStore()

const store = useStore()
const router = useRouter()

const context = computed(() => store.state.global.context)
const frontendVersion = computed(() => store.state.global.frontendVersion)

const initialOrgId = computed(() => {
  if (store.getters['global/organisation']) {
    return store.getters['global/organisation'].id
  } else {
    return null
  }
})

const hasOrganisationSelection = computed(() => {
  const organisations = store.getters['global/contextOrganisations']
  return (
    organisations &&
    organisations.objects.length > 1 &&
    store.getters['global/organisation']
  )
})

const selectOrganisation = async (organisation) => {
  if (organisation && context.value.selection.organisation !== organisation) {
    store.commit('global/clearContextSelection')
    store.commit('global/setOrganisationIsSwitching', true)
    try {
      await router.push({
        name: 'organisation',
        params: {
          org_slug: organisation.slug,
        },
      })
    } catch (error) {
      console.error('Error while switching organisation:', error)
    }
    store.commit('global/setOrganisationIsSwitching', false)
  }
}
</script>

<style lang="scss" scoped>
.context-selection {
  bottom: 0;
  position: absolute;
  max-width: 180px;
  margin-bottom: 10px;
}

#close-child-menu {
  float: right;
}

.button:deep(span:first-child) {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>

<style lang="scss">
#dashboard-menu {
  max-height: calc(100vh - 64px);
  overflow-y: auto;
}

.has-organisation-selection #dashboard-menu {
  max-height: calc(100vh - 120px);
}
</style>
